import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="abortsignal" id="abortsignal"></a>
    <h1 {...{
      "id": "windowabortsignal"
    }}>{`window.AbortSignal`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal`}</a></p>
    <br></br>
Please note that AbortSignal works only for web streams.  
    <a name="abortsignal-aborted" id="abortsignal-aborted"></a>
    <h2 {...{
      "id": "aborted--boolean"
    }}>{`aborted : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Whether the request that the signal is communicating with is aborted or not`}</p>
    <a name="abortsignal-reason" id="abortsignal-reason"></a>
    <h2 {...{
      "id": "reason--"
    }}>{`reason : `}<inlineCode parentName="h2">{`*`}</inlineCode></h2>
    <p>{`The abort reason, once the signal has aborted.
`}<inlineCode parentName="p">{`Undefined`}</inlineCode>{` when the signal has not been aborted.`}</p>
    <a name="abortsignal-throwifaborted" id="abortsignal-throwifaborted"></a>
    <h2 {...{
      "id": "throwifaborted"
    }}>{`throwIfAborted()`}</h2>
    <p>{`Throws the signal's abort reason if the signal has been aborted.
Otherwise, it does nothing.`}</p>
    <a name="abortsignal-abort" id="abortsignal-abort"></a>
    <h2 {...{
      "id": "abortreason"
    }}>{`abort(reason)`}</h2>
    <p>{`Creates an AbortSignal object that is already set as aborted.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`AbortSignal`}</inlineCode>{` - AbortSignal object with the AbortSignal.aborted property is set to true
and AbortSignal.reason set to the specified or default reason  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`reason`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*`}</inlineCode></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      